<div class="loader-overlay" *ngIf="currentStatus">
    <div class="loader"></div>
</div>
